var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"form__draw form__draw--radio mr-1-2 inline-block",class:{
    'form__draw--radio': _vm.isSingle,
    'form__draw--checkbox': _vm.isMultiple,
    'form__draw--input': _vm.isInput,
    'form__draw--picture': _vm.isPicture,
    'form__draw--other': _vm.isOther
  }})}
var staticRenderFns = []

export { render, staticRenderFns }